import { createSelector } from "reselect";
import { RootState } from "../../rootReducer";

export const selectCreateStep = createSelector(
  [(store: RootState) => store.massiveDocumentCreate.createStep],
  (step) => step
);
